import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  sectionIsLockedSelector,
  sectionHasErrorsSelector,
  sectionIsValidSelector,
} from 'selectors/validation';
import { SF852013 } from 'constants/formTypes';

export var SectionLink = function ({
  section, basePath, formType, errors, completed, locked
}) {
  const url = `${basePath}/${section.path}`;

  const showStatus = !(section.path === 'review' || section.path === 'intro');

  const classes = classnames('section-link', {
    locked,
    'has-errors': errors,
    'is-valid': completed,
  });

  const ariaLabel = classnames({
    Locked: locked,
    'Has errors': errors,
    Completed: completed,
  });

  const handleClick = (e) => {
    if (locked) { e.preventDefault(); }
  };

  // hardcoded for SF85 v2013
  let sectionLabel = section.label;
  if (formType === SF852013 && section.label === 'U.S. military') {
    sectionLabel = 'Military history';
  }

  return (
    <li>
      <NavLink
        to={url}
        activeClassName="usa-current"
        className={classes}
        onClick={handleClick}
        aria-label={`Display section: ${sectionLabel}`}
      >
        <span className="section-name" aria-label={sectionLabel}>{sectionLabel}</span>
        {showStatus && (
          <span
            className="eapp-status-icon"
            role="img"
            aria-label={`Section status: ${ariaLabel || 'Incomplete'}`}
          />
        )}
      </NavLink>
    </li>
  );
};

SectionLink.propTypes = {
  basePath: PropTypes.string,
  formType: PropTypes.string,
  errors: PropTypes.bool,
  completed: PropTypes.bool,
  locked: PropTypes.bool,

  section: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
};

SectionLink.defaultProps = {
  basePath: '',
  formType: '',
  completed: false,
  errors: false,
  locked: false,
};

const mapStateToProps = (state, ownProps) => ({
  ...sectionHasErrorsSelector(state, ownProps),
  ...sectionIsValidSelector(state, ownProps),
  ...sectionIsLockedSelector(state, ownProps),
  formType: state.application.Settings.formType,
});

export default withRouter(connect(mapStateToProps)(SectionLink));
